import {Component, input} from '@angular/core';

/**
 * Green 32×32 tile with a Font Awesome icon, used in section headers.
 * `icon` is the Font Awesome name without prefix, e.g. "bullseye" or "clock".
 */
@Component({
    selector: 'app-icon-tile',
    templateUrl: './icon-tile.component.html',
    styleUrl: './icon-tile.component.scss',
    host: {
        '[class.small]': 'size() === "sm"',
        '[attr.title]': 'label() || null',
        'aria-hidden': 'true'
    }
})
export class IconTileComponent {
    readonly icon = input.required<string>();
    readonly variant = input<'regular' | 'solid' | 'light'>('regular');
    readonly size = input<'sm' | 'md'>('md');
    readonly label = input<string>();
}
